import Vue from 'vue'

const SPECIFICATION_SET_NAME =(state, payload)=> {
            
    state.data.name = payload
};


const SPECIFICATION_SET_DUPLICATE =(state, payload)=> {
            
    state.data.duplicate = payload
};

const SPECIFICATION_SET_SPECIFICATIONS =(state, payload)=> {  
    
    state.specifications=payload
    
};

const SPECIFICATION_SET_SPECIFICATION =(state, payload)=> {       
    
    state.data.name = payload.name
        
};

const SPECIFICATION_INIT_SPECIFICATION =(state, payload)=> {       
    state.data.name = ''    
    
};


export default {
    SPECIFICATION_SET_NAME,
    SPECIFICATION_SET_DUPLICATE,
    SPECIFICATION_SET_SPECIFICATIONS,
    SPECIFICATION_SET_SPECIFICATION,
    SPECIFICATION_INIT_SPECIFICATION,
};